import { ValueOf } from './util';

export const bulkGrantStatus = {
  UPLOAD_PROGRESS: 'アップロード中',
  SCHEDULED: '付与予定',
  PROGRESS: '処理中',
  DONE: '処理完了',
  UPLOAD_FAILURE: 'アップロード失敗',
  SCHEDULE_CANCELED: '付与予定取消',
  FAILURE: '処理失敗',
} as const;

export type BulkGrantStatusKey = keyof typeof bulkGrantStatus;
export type BulkGrantStatusValue = ValueOf<typeof bulkGrantStatus>;

export const invertedBulkGrantStatus = {
  [bulkGrantStatus.UPLOAD_PROGRESS]: 'UPLOAD_PROGRESS',
  [bulkGrantStatus.SCHEDULED]: 'SCHEDULED',
  [bulkGrantStatus.PROGRESS]: 'PROGRESS',
  [bulkGrantStatus.DONE]: 'DONE',
  [bulkGrantStatus.UPLOAD_FAILURE]: 'UPLOAD_FAILURE',
  [bulkGrantStatus.SCHEDULE_CANCELED]: 'SCHEDULE_CANCELED',
  [bulkGrantStatus.FAILURE]: 'FAILURE',
};

export const bulkGrantStatusKeys = Object.keys(bulkGrantStatus) as (BulkGrantStatusKey[]);

/** v-select用items */
export const bulkGrantStatusItems = bulkGrantStatusKeys
  .map((key) => ({
    title: bulkGrantStatus[key],
    value: key,
  }));
